import { AcDomain } from 'api/interfaces/AcDomain'

import { defaultTransformFn, platformApi } from './platformApi'

const domainsTags = platformApi.enhanceEndpoints({ addTagTypes: ['Domains'] })

export const domainsApi = domainsTags.injectEndpoints({
  endpoints: build => ({
    getDomains: build.query<AcDomain[], void>({
      query: () => ({
        url: 'domains',
        method: 'GET',
        isContext: true,
        isAgency: false
      }),
      transformResponse: defaultTransformFn,
      providesTags: ['Domains']
    })
  })
})

export const { useGetDomainsQuery, useLazyGetDomainsQuery } = domainsApi
